var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.166 18.6667V22.1667C22.166 22.4761 22.0431 22.7728 21.8243 22.9916C21.6055 23.2104 21.3088 23.3333 20.9993 23.3333H6.99935C6.38051 23.3333 5.78702 23.0875 5.34943 22.6499C4.91185 22.2123 4.66602 21.6188 4.66602 21V7",
    stroke: "#33CCCC",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.33301H21C21.3094 9.33301 21.6062 9.45592 21.825 9.67472C22.0438 9.89351 22.1667 10.1903 22.1667 10.4997V13.9997",
    stroke: "#33CCCC",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 14V18.6667H18.6673C18.0485 18.6667 17.455 18.4208 17.0174 17.9832C16.5798 17.5457 16.334 16.9522 16.334 16.3333C16.334 15.7145 16.5798 15.121 17.0174 14.6834C17.455 14.2458 18.0485 14 18.6673 14H23.334Z",
    stroke: "#33CCCC",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8327 9.33366V5.83366C19.8327 5.52424 19.7098 5.22749 19.491 5.0087C19.2722 4.78991 18.9754 4.66699 18.666 4.66699H6.99935C6.38051 4.66699 5.78702 4.91282 5.34943 5.35041C4.91185 5.78799 4.66602 6.38149 4.66602 7.00033C4.66602 7.61916 4.91185 8.21266 5.34943 8.65024C5.78702 9.08783 6.38051 9.33366 6.99935 9.33366",
    stroke: "#33CCCC",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolit);
export default __webpack_public_path__ + "static/media/volit.36b984a75caac205ab0df3b96e5705c0.svg";
export { ForwardRef as ReactComponent };